import { render } from 'datocms-structured-text-to-plain-text';
import { EventJsonLd, NextSeo, NextSeoProps } from 'next-seo';

import { urlFor } from 'utils/routes.utils';
import { notEmpty } from 'utils/typescript.utils';

import { Routes } from 'constants/routes.constants';
import {
  PageEventFragment,
  SeoFragment,
} from 'types/api/dato-operations.types';

import {
  convertToNextSeoProps,
  noIndexUnlistedEvents,
} from 'components/@seo/utils';

interface Props extends NextSeoProps {
  tags?: Array<SeoFragment>;
  event: PageEventFragment;
}

const EventSeo = ({ tags = [], event, ...props }: Props) => {
  const eventImages = [event.cover?.url, event.venue.media.url].filter(
    notEmpty,
  );

  return (
    <>
      <NextSeo
        {...convertToNextSeoProps(tags)}
        {...noIndexUnlistedEvents(event.unlistedEvent)}
        {...props}
      />

      <EventJsonLd
        name={event.title ?? ''}
        description={render(event.description) ?? ''}
        url={urlFor(Routes.EventDetail, { slug: event.slug })}
        images={eventImages}
        eventAttendanceMode="OfflineEventAttendanceMode"
        eventStatus="EventScheduled"
        startDate={event.startDatetime ?? ''}
        endDate={event.endDatetime ?? ''}
        organizer={{
          type: 'Organization',
          name: 'MDLBEAST',
          url: urlFor(Routes.Home),
        }}
        location={{
          name: event.venue?.name,
          address: {
            streetAddress: event.venue?.streetAddress,
            addressLocality: event.venue?.addressLocality,
            addressRegion: event.venue?.addressRegion,
            postalCode: event.venue?.postalCode,
            addressCountry: event.venue?.addressCountry,
          },
        }}
        performers={event.performers.map((performer) => ({
          type: 'Person',
          name: performer.name,
        }))}
      />
    </>
  );
};

export default EventSeo;
